import { render } from "./whyIlearndSection.vue?vue&type=template&id=60126d7c&scoped=true"
const script = {}

import "./whyIlearndSection.vue?vue&type=style&index=0&id=60126d7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60126d7c"]])

export default __exports__